(function () {
	'use strict';

	angular
		.module('app.setup')
		.service('leandnaConnectKeyConfigService', leandnaConnectKeyConfigService);

	leandnaConnectKeyConfigService.$inject = ['$http'];

	function leandnaConnectKeyConfigService($http) {
		var baseUrl = '/api/2/factndx/{0}/leandnaConnectKey/';

		return {
			getLeandnaConnectKeyList: getLeandnaConnectKeyList,
			deleteLeandnaConnectKey: deleteLeandnaConnectKey,
			createLeandnaConnectKey: createLeandnaConnectKey
		};


		function getLeandnaConnectKeyList(siteId) {

			var url = String.format(baseUrl, siteId);
			return $http.get(url)
				.then(getLeandnaConnectKeyListSuccess, getLeandnaConnectKeyListError);

			function getLeandnaConnectKeyListSuccess(response) {
				// check for empty, set showAnchor based on that
				if (response.status === 204) {
					return response.status;
				}
				if (response.data.length === 0) {
					return response.status;
				}

				// Process dates for viewing
				response.data.forEach(function (leandnaConnectRow, index) {
					// Prepare for Red cell
					if (leandnaConnectRow.dateExpires <= Date.now()) {
						leandnaConnectRow.keyExpired = true;
					} else leandnaConnectRow.keyExpired = false;
					// Split up Time and Date
					leandnaConnectRow.dateCreated = new Date(leandnaConnectRow.dateCreated).toLocaleString();
					leandnaConnectRow.dateCreatedPart = leandnaConnectRow.dateCreated.split(',')[0];
					leandnaConnectRow.timeCreatedPart = leandnaConnectRow.dateCreated.split(',')[1];
					// Special case for Null Expire date
					if (leandnaConnectRow.dateExpires === null) {
						leandnaConnectRow.dateExpiresPart = 'Does Not';
						leandnaConnectRow.timeExpiresPart = 'Expire';
						leandnaConnectRow.keyExpired = false;
					} else {
						leandnaConnectRow.dateExpires = new Date(leandnaConnectRow.dateExpires).toLocaleString();
						leandnaConnectRow.dateExpiresPart = leandnaConnectRow.dateExpires.split(',')[0];
						leandnaConnectRow.timeExpiresPart = leandnaConnectRow.dateExpires.split(',')[1];
					}

				}, response.data);
				return response.data;
			}
			function getLeandnaConnectKeyListError(error) {
				return error;
			}
		}

		function createLeandnaConnectKey(siteId, leandnaConnectKey) {
			var url = String.format(baseUrl, siteId);
			return $http.post(url, leandnaConnectKey)
				.then(leandnaConnectKeySuccess, leandnaConnectKeyKeyError);

			function leandnaConnectKeySuccess(response) {
				return response;
			}
			function leandnaConnectKeyKeyError(error) {
				if (error.status === 400) {
					return error.data.reason;
				}
				if (error.status === 409) {
					return error.data.reason;
				}
				return 'Server error';
			}
		}

		function deleteLeandnaConnectKey(siteId, deleteKey) {
			var url = String.format(baseUrl, siteId) + deleteKey.keyId;
			
			return $http.delete(url)
				.then(deleteSFTPKeySuccess, deleteSFTPKeyError);

			function deleteSFTPKeySuccess(response) {
				return 'LeanDNA Connect Key deleted successfully';
			}
			function deleteSFTPKeyError(error) {
				return error;
			}
		}
	}
})();
